export default __webpack_public_path__ + "static/media/trading-platform-mobile.8f598e49.jpg";